import { useMemo, useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
// Helpers
import { getStreamRecordsFromV2, StreamRecordDisplay } from 'helpers/streams';
// Types
import { GetStream_stream } from 'api/streams/types/GetStream';

/**
 * Returns stream records for display using streamRecordsV2.
 * On mobile: portrait video; on desktop: landscape.
 *
 * Uses useEffect to ensure client-side detection after hydration,
 * preventing SSR mismatch where server might not detect mobile correctly.
 */
export function useStreamRecordsForDisplay(
  stream: GetStream_stream | null | undefined
): StreamRecordDisplay[] {
  const [isMobileClient, setIsMobileClient] = useState(false);

  useEffect(() => {
    setIsMobileClient(isMobile);
  }, []);

  return useMemo(() => getStreamRecordsFromV2(stream, isMobileClient), [
    stream,
    isMobileClient,
  ]);
}
